import i18n from "_i18n/i18n";

import { IFile, ImageFile } from '../types/globalTypes';
import { AvailableFormats, MaxFileSize } from './constants/constants';

import * as Yup from 'yup';
import { toast } from 'react-toastify';

const nbsp = '\xa0';

export const validationMessage = {
  get invalidEmail() {
    return i18n.t("validation.invalidEmail");
  },
  get invalidImage() {
    return i18n.t("validation.invalidImage");
  },
  get invalidNip() {
    return i18n.t("validation.invalidNip");
  },
  get invalidPdf() {
    return i18n.t("validation.invalidPdf");
  },
  get invalidFile() {
    return i18n.t("validation.invalidFile");
  },
  get invalidPesel() {
    return i18n.t("validation.invalidPesel");
  },
  get invalidPhone() {
    return i18n.t("validation.invalidPhone");
  },
  get isRequired() {
    return i18n.t("validation.isRequired");
  },
  get isRequiredOneOf() {
    return i18n.t("validation.isRequiredOneOf");
  },
  get weekPassword() {
    return i18n.t("validation.weekPassword");
  },
  get passwordsDontMatch() {
    return i18n.t("validation.passwordsDontMatch");
  },
  minItems: (minItems: number) =>
    i18n.t("validation.minItems", { minItems }),
  length: (length: number) => i18n.t("validation.length", { length }),
  min: (length: number) => i18n.t("validation.min", { length }),
  max: (length: number) => i18n.t("validation.max", { length }),
};

export const validateFile = {
  image: (name: string) =>
    Yup.mixed().test({
      name,
      message: validationMessage.invalidImage,
      test: (fileData: ImageFile) => {
        if (!fileData?.file) {
          return true;
        }

        if (
          fileData.file.size > MaxFileSize.Image ||
          !AvailableFormats.Image.includes(fileData.file.type)
        ) {
          return false;
        }

        return true;
      },
    }),
  pdf: (name: string) =>
    Yup.mixed().test({
      name,
      message: validationMessage.invalidPdf,
      test: (fileData: IFile) => {
        if (!fileData?.file) {
          return true;
        }

        if (
          fileData.file.size > MaxFileSize.Pdf ||
          !AvailableFormats.Pdf.includes(fileData.file.type)
        ) {
          return false;
        }

        return true;
      },
    }),
  storedFile: (name: string) =>
    Yup.mixed().test({
      name,
      message: validationMessage.invalidFile,
      test: (fileData: IFile) => {
        if (!fileData?.file) {
          return true;
        }

        if (
          fileData.file.size > MaxFileSize.StoragedFile ||
          !AvailableFormats.StoragedFile.includes(fileData.file.type)
        ) {
          return false;
        }

        return true;
      },
    }),
};

export const validateNip = (nip: string) => {
  if (!nip || !nip.match(/^[0-9]{10}$/)) {
    return false;
  }

  const nipWeights = [6, 5, 7, 2, 3, 4, 5, 6, 7];
  return isCorrectNipControlSum(nip, nipWeights);
};

const isCorrectNipControlSum = (nip: string, weights: Array<number>) => {
  const sum = weights.reduce((acc, cur, i) => acc + parseInt(nip[i]) * cur, 0);

  if (sum === 0) {
    return false;
  }

  const controlSum = sum % 11 === 10 ? 0 : sum % 11;
  return controlSum === parseInt(nip[weights.length]);
};

export const validatePesel = (pesel: string) => {
  if (!pesel || !pesel.match(/^[0-9]{11}$/)) {
    console.log('match');
    return false;
  }

  const month = parseInt(pesel.substring(2, 4));
  if (!month || month % 20 > 12) {
    console.log('month');
    return false;
  }

  const day = parseInt(pesel.substring(4, 6));
  if (!day || day < 1 || day > 31) {
    console.log('day');
    return false;
  }

  const peselWeights = [1, 3, 7, 9, 1, 3, 7, 9, 1, 3];
  return isCorrectPeselControlSum(pesel, peselWeights);
};

const isCorrectPeselControlSum = (pesel: string, weights: Array<number>) => {
  const sum = weights.reduce((acc, cur, i) => {
    const currentValue = parseInt(pesel[i]) * cur;
    return acc + (currentValue % 10);
  }, 0);

  if (sum === 0) {
    return false;
  }

  const controlSum = 10 - (sum % 10);
  
  return controlSum === parseInt(pesel[weights.length]);
};

export const validateRequiredFields = <T extends {}>(object: T) => {
  const entries = Object.entries(object);

  let errors: string[] = [];
  entries.map(entry => {
    const key = entry[0];
    const value = entry[1];

    if (value === '' || value === 0) {
      errors = [...errors, `"${key}" jest wymaganym polem`];
    }
  });

  if (errors.length) {
    errors.map(error => toast.error(error));
    return false;
  }

  return true;
};
